import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../selectors/users';
import {
  getModuleType,
  getModuleMeta,
  getModuleVersion,
  canPerformModuleAction,
} from '../../../../selectors/modules';
import { canPerformPageAction } from '../../../../selectors/groups';
import { updateModule } from '../../../../actions/modules';
import { ModulePriv } from '../../../../../types/modules';
import { PagePriv } from '../../../../../types/pagePrivileges';
import { Props } from './WidgetBoxWide';

export type ConnectedKeys =
  | 'profileOwnerUser'
  | 'isCurrentUserProfileOwner'
  | 'moduleType'
  | 'moduleVersion'
  | 'isAuthorizedToEditWidget'
  | 'isAuthorizedToRemoveWidget'
  | 'isNewlyAddedModule';
export type StateProps = Pick<Props, ConnectedKeys>;
export type DispatchProps = Pick<Props, 'updateModule'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  { moduleId }
) => ({
  isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
  profileOwnerUser: getProfileOwnerUser(state),
  moduleType: getModuleType(state, moduleId),
  moduleVersion: getModuleVersion(state, moduleId),
  isNewlyAddedModule: getModuleMeta(state, moduleId).isNewlyAdded,
  isAuthorizedToMoveModule: canPerformPageAction(state, PagePriv.MOVE_MODULE),
  isAuthorizedToRemoveWidget: canPerformModuleAction(
    state,
    moduleId,
    ModulePriv.DELETE
  ),
  isAuthorizedToEditWidget: canPerformModuleAction(
    state,
    moduleId,
    ModulePriv.EDIT
  ),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  updateModule,
};
export default connect(mapStateToProps, mapDispatchToProps);
